import { AxiosResponse } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import AxiosInstance from './AxiosInstance';

export const sendEmailResetPassword = async (email: string): Promise<AxiosResponse> => {
  const params = {
    message: JSON.stringify({
      msg: 'method',
      id: uuidv4(),
      method: 'sendForgotPasswordEmail',
      params: [email],
    }),
  };
  return AxiosInstance.post('method.callAnon/sendForgotPasswordEmail', params);
};
